// removed by extract-text-webpack-plugin
module.exports = {"root":"order-logs--root--3laX-VcM","odd":"order-logs--odd--398fPG7V","even":"order-logs--even--3HfP4HSK","invoice-list":"order-logs--invoice-list--5CxPsduR","invoiceList":"order-logs--invoice-list--5CxPsduR","key":"order-logs--key--2z1U502W"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/order-logs/styles.css
// module id = ./views/order-detail/order-logs/styles.css
// module chunks = 0